'use client'

import { useState } from 'react'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import { Grid, IconButton } from '@mui/material'
import { Spinorama, SpinoramaWrapper, SpinoramaItem, SpinoramaThumbnail, SpinoramaThumbnails } from 'spinorama'

// Types
import type { SlideshowProps } from '@/types/components/molecules/sliders/slideshow'
import type { CardItem } from '@/types/components/molecules/cards'

// Components
const SlideshowBoxCardMolecule = dynamic(() => import('@/components/molecules/cards/slideshow-box'))

const SlideshowMolecule = (props: SlideshowProps) => {
	// Props
	const { lng, items } = props

	// Variables
	const [selectedIndex, setSelectedIndex] = useState<number | null>(null)

	return (
		<Spinorama>
			<SpinoramaWrapper alignItems="stretch">
				{items.map((item, index) => {
					const fv = item.fields_values

					// Box
					const box: CardItem = {}

					if (Array.isArray(fv) && fv.length > 5) {
						box.title = fv[3].value ?? item.title
						box.link = `/article/${item.alias}`
						box.year = fv[0].value
						box.subtitle = fv[1].value
						box.description = fv[5].value
					}

					return (
						<SpinoramaItem
							key={index}
							size={12}
							height={{ xs: 'calc(80dvh - 48px)', sm: 'calc(80dvh - 64px)', lg: 'calc(80dvh - 80px)', xl: 'calc(80dvh - 100px)' }}
							position="relative"
							sx={{
								'& > img': {
									width: 1,
									height: 'auto',
									filter: 'grayscale(100%)',
									objectFit: 'cover',
									objectPosition: 'center'
								},
								'& picture': {
									width: 1,
									height: 1,
									'& > img': {
										width: 1,
										height: 1,
										filter: 'grayscale(100%)',
										objectFit: 'cover',
										objectPosition: 'center'
									}
								}
							}}
						>
							{items.length === 1 ? (
								<Image src={`/api/download${item.image}`} alt={item.title} width={1440} height={800} />
							) : (
							<picture>
								<img src={`/api/download${item.image}`} alt={item.title} />
							</picture>
							)}

							<Grid position="absolute" bottom={40} left="50%" zIndex={1} sx={{ transform: 'translateX(-50%)' }}>
								<SlideshowBoxCardMolecule lng={lng} {...box} />
							</Grid>
						</SpinoramaItem>
					)
				})}
			</SpinoramaWrapper>

			{items && items.length > 1 ? (
				<Grid spacing={2} top={-35} position="relative">
					<SpinoramaThumbnails justify="center">
						{items.map((_, index) => (
							<SpinoramaThumbnail key={index} px={1.75}>
								<IconButton
									sx={{
										width: 25,
										height: 25,
										p: 0,
										bgcolor: selectedIndex === index ? 'primary.main' : '#fff',
										border: selectedIndex === index ? '2px solid white' : 'none',
										borderRadius: '50%',
										transition: 'background-color 0.3s, border 0.3s',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center'
									}}
									onClick={() => setSelectedIndex(index)}
								/>
							</SpinoramaThumbnail>
						))}
					</SpinoramaThumbnails>
				</Grid>
			) : null}
		</Spinorama>
	)
}

export default SlideshowMolecule
